import React, { useEffect } from "react";
import PosTypes from "../PosTypes";
import { useParams } from "react-router-dom";
import callApi from "../../../../../utils/api-client";
import { PosAcc } from "../../../../../types/pos";
import { GenericResultResponse } from "../../../../../types/common";
import { useDispatch } from "react-redux";
import { updateIsLoading } from "../../../../../reducerSlices/loaderSlice";

function PosTypeLinkedById() {
  const { posId } = useParams();
  const [posAccount, setPosAccount] = React.useState<PosAcc | undefined>(
    undefined
  );
  const dispatch = useDispatch();

  const getPosAccountDetailsById = async (id: string | undefined) => {
    try {
      dispatch(updateIsLoading(true));
      const response = await callApi<GenericResultResponse<PosAcc>>(
        `admin/pos/${id}`,
        {
          method: "GET",
        },
        "getPosAccountDetailsById_PosTypeLinkedById"
      );

      if (!response) {
        return undefined;
      }
      setPosAccount(response.data);
    } catch (error) {
      console.error("Error fetching POS account details:", error);
    } finally {
      dispatch(updateIsLoading(false));
    }
  };

  useEffect(() => {
    getPosAccountDetailsById(posId);
  }, []);

  if (!posAccount) {
    return <></>;
  }

  return <PosTypes posAccount={posAccount} />;
}

export default PosTypeLinkedById;
